import {BOOLEAN_FIELD_TYPE,  NUMERIC_RANGE_FIELD_TYPE,  TEXT_FIELD_TYPE } from "../../../../helpers/constants";
import i18n from "../../../../i18n";
import SelectFieldService from "../../../../services/selectFieldService";
import ModeEditOutlineOutlined from "@mui/icons-material/ModeEditOutlineOutlined";


export const POST_DELIVERY_TABLE_NAME = "post_delivery_table";
export const POST_DELIVERY_TABLE_CONFIG = [
  {
    name: "delivery_name",
    getValueCallback: (rowData) => rowData.delivery_name,
    label: i18n.t("table.correspondence_admin.delivery_name"),
    filterType: TEXT_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  },
  {
    name: "delivery_cost",
    getValueCallback: (rowData) => rowData.delivery_cost,
    label: i18n.t("table.correspondence_admin.delivery_cost"),
    filterType: NUMERIC_RANGE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  },
  {
    name: "delivery_active",
    getValueCallback: (rowData) =>
      SelectFieldService.getLabelOptionsTrueOrFalse(rowData.delivery_active),
    label: i18n.t("table.correspondence_admin.delivery_active"),
    filterType: BOOLEAN_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  },
  {
    name: "edit",
    getValueCallback: (rowData, onClickEdit) => {
      return (
        <ModeEditOutlineOutlined
          onClick={(e) => onClickEdit(e, rowData.id)}
        />
      );
    },
    label: i18n.t("table.correspondence_admin.edit"),
    filterType: null,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  }
];
